import './bulletinModal.scss';

interface BulletinModalInterface {
  modalInfo: {
    boton: {
      copy: string;
      redireccion: string;
    }[];
    descripcion?: {
      raw?: any;
    };
    nombre: string;
    referencias: {
      copy: string;
      redireccion: string;
      nombre: string;
    }[];
    subtitulo: string;
  };
  setSelectedButtons: Function;
  selectedButtons: any;
  setBulletinModal: Function;
  onButtonClick?: Function;
}

const BulletinModal = ({
  modalInfo,
  selectedButtons,
  setSelectedButtons,
  setBulletinModal,
  onButtonClick,
}: BulletinModalInterface) => {
  const getButtonClass = (copy) => {
    if (selectedButtons && selectedButtons.length > 0) {
      return selectedButtons.find((elementS) => elementS === copy) !== undefined
        ? '--selected'
        : '';
    }
    return '';
  };

  const addButtonSelected = (item) => {
    const list: any =
      selectedButtons && selectedButtons.length > 0 ? [].concat(selectedButtons) : [];

    if (list && list.length > 0) {
      const elementIndex = list.indexOf(item);
      if (elementIndex === -1) {
        list.push(item);
        setSelectedButtons(list);
      } else {
        const result = list.filter((elem) => elem !== item);
        setSelectedButtons(result);
      }
    } else {
      list.push(item);
      setSelectedButtons(list);
    }
  };

  return (
    <div className="m-bulletin-modal">
      <i
        className="icon-close"
        onClick={() => {
          setBulletinModal(false);
        }}
      />
      <div className="m-bulletin-modal__content">
        <div className="m-bulletin-modal__content__headings">
          <h3>{modalInfo?.nombre}</h3>
          <p>{modalInfo?.subtitulo}</p>
        </div>
        <div className="m-bulletin-modal__content__interaction">
          <div className="m-bulletin-modal__content__interaction__content">
            {modalInfo?.referencias &&
              modalInfo?.referencias?.map((info, index) => {
                return (
                  <button
                    className={`m-bulletin-modal__content__interaction__content__button ${getButtonClass(
                      info?.copy || info?.nombre,
                    )}`}
                    key={`m-bulletin-modal__content__interaction__button${index}`}
                    onClick={() => {
                      addButtonSelected(info?.copy || info?.nombre);
                    }}
                  >
                    {info?.copy || info?.nombre}
                  </button>
                );
              })}
          </div>
        </div>
        <div className="m-bulletin-modal__content__note">
          <p>Debes seleccionar por lo menos cuatro favoritos.</p>
        </div>
        <button
          className="m-bulletin-modal__content__button"
          disabled={!(selectedButtons && selectedButtons.length > 3)}
          onClick={() => {
            setBulletinModal(false);
            onButtonClick && onButtonClick();
          }}
        >
          {modalInfo?.boton?.[0]?.copy}
        </button>
      </div>
    </div>
  );
};

export default BulletinModal;
